/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import $ from '@/jquery'

const lasso = $('<div class="absolute lasso bg-accent-10 border rounded-lg" style="left: calc(var(--weekview-time-column-gap) + var(--weekview-time-column-width)); right: 0; width: auto;">').hide().get(0)
let startTime = null
let cellSize = 28
let firstY = 0
let dragging = false

export function addLasso ($el, callback = () => {}) {
  $el
    .append(lasso)
    .on('mousedown', '.day', () => $el.on('mousemove', '.day', onMove))
    .on('mouseup ', '.day', function (e) {
      const [start, end] = onMove.call(this, e)
      if (end > start) callback(start, end)
      off($el)
    })
    .on('mouseleave', () => off($el))
  $el.closest('[tabindex="0"]')
    .on('keydown', e => { if (e.keyCode === 27) off($el) })
}

function off ($el) {
  $el.off('mousemove', '.day', onMove)
  lasso.style.display = 'none'
  startTime = null
  firstY = 0
  dragging = false
}

function onMove (e) {
  const rect = this.getBoundingClientRect()
  const y = Math.max(0, e.clientY - rect.top)

  if (startTime === null) {
    cellSize = $(this).find('.timeslot:first').outerHeight()
    startTime = Math.floor(y / cellSize)
    firstY = y
    return [0, 0]
  }

  if (!dragging && Math.abs(firstY - y) <= 10) return [0, 0]
  dragging = true

  const endTime = Math.floor(y / cellSize)
  const [start, end] = orderTime(startTime, endTime)
  Object.assign(lasso.style, {
    top: `${start * cellSize}px`,
    height: `${(end - start) * cellSize}px`,
    display: 'block'
  })
  return [start, end]
}

function orderTime (start, end) {
  if (start === end) return [start, end + 1]
  return end > start ? [start, end] : [end, start]
}
